import { render } from "./TierlistView.vue?vue&type=template&id=16d78b67"
import script from "./TierlistView.vue?vue&type=script&lang=js"
export * from "./TierlistView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__